import React from "react";
import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";

/**
 * Collapsed-by-default control for Exam2 differential tips (hints render under systems).
 */
const Exam2TipsPanel = ({ open, onToggle, hasTips = false, otherTips = [] }) => {
  if (!hasTips) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LightbulbOutlined color="action" fontSize="small" />
          <Typography variant="subtitle1">Findings to look for</Typography>
        </Box>
        <IconButton
          size="small"
          aria-label={open ? "Hide exam tips" : "Show exam tips"}
          aria-expanded={open}
          onClick={onToggle}
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: (theme) =>
              theme.transitions.create("transform", {
                duration: theme.transitions.duration.shortest,
              }),
          }}
        >
          <ExpandMoreRounded />
        </IconButton>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {open
          ? "Hints are shown under each exam section."
          : "Expand to show hints under each exam section."}
      </Typography>
      {open && otherTips.length > 0 ? (
        <Stack spacing={0.75} sx={{ mt: 1.5 }}>
          <Typography variant="subtitle2">Other</Typography>
          {otherTips.map((tip) => (
            <Typography key={tip.examName} variant="body2" color="text.secondary">
              {tip.examName}
              {tip.lookFor?.length ? ` — ${tip.lookFor.join("; ")}` : ""}
              {tip.diagnoses?.length ? ` (${tip.diagnoses.join(", ")})` : ""}
            </Typography>
          ))}
        </Stack>
      ) : null}
    </Paper>
  );
};

export default Exam2TipsPanel;
